import { KitStockComponentTypeEnum } from './../../../acumatica/EntityServices/KitSpecification.service';
import { BinderShell } from '../../../acumatica/EntityServices/SampleBooks.service';
import { Router } from '@angular/router';
import { ConfirmationDialog } from './../../../common/confirmation-dialog/confirmation-dialog.component';
import { Sound } from './../../../services/audio.service';
import { MatDialog } from '@angular/material/dialog';
import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';
import { SampleBooksService, CardAuditFillSourceEnum, OrderComponent, OrderComponents } from 'src/app/acumatica/EntityServices/SampleBooks.service';
import { ApplicationScreen } from 'src/app/application-navigator/application-screen';
import { Component, OnInit } from '@angular/core';
import { AlertDialog } from 'src/app/common/alert-dialog/alert-dialog.component';
import { Observable } from 'rxjs';
import { CustomerLocation, CustomerLocationService } from 'src/app/acumatica/EntityServices/Customer.service';
import { AcumaticaLoadingDialogComponent } from 'src/app/acumatica/loading-indicator/loading-dialog-indicator.component';
import { RepOrderShipToEnum } from 'src/app/common/general-components';
import { LoadingIndicator } from 'src/app/acumatica/loading-indicator/AcumaticaLoadingOptions';
import { LogService } from 'src/app/services/logging.service';
import { AcumaticaService } from 'src/app/acumatica/acumatica.service';

@Component({
  selector: 'app-card-audit-review',
  templateUrl: './card-audit-review.component.html',
  styleUrls: ['./card-audit-review.component.css']
})
export class CardAuditReviewComponent extends ApplicationScreen implements OnInit {
  LowSupplyQtyThreshold = 20;
  pageTitle = "Binder Audit Review";
  orderCards?: OrderComponent[];
  orderBinders?: OrderComponent[];
  showEmptyBinders: boolean = false;

  constructor(
    private binders: SampleBooksService,
    private acumatica: AcumaticaService,
    private mayerfabrics: MayerFabricsService,
    private customerLocationsService: CustomerLocationService,
    private dialog: MatDialog,
    private router: Router,
    private logger: LogService,
  ) {
    super();

    if (false && this.isDevMode) {
      this.binders.GetAllBindersContents().subscribe(() => {
        Object.keys(binders.BinderShelf).forEach(key => {
          var binder = binders.BinderShelf[key];
          binder.UserAudited = true;
          for (let i = 0; i < binder.StockComponents.length; i++) {
            if (i != 2) binders.AuditCard(binder.StockComponents[i]);
          }
        });
      });
    }
  }

  // #region UI template exposure
  CardAuditFillSource = CardAuditFillSourceEnum; // make enum options available for mat-button-toggle's
  RepOrderShipToEnum = RepOrderShipToEnum;
  BinderShells = this.binders.BinderShells;
  binderShellOrderStatus = (shell: BinderShell) => this.binders.binderShellOrderStatus(shell);
  toggleBinderShellCheck = (shell: BinderShell) => this.binders.toggleShellOrderStatus(shell);
  get shipTo(): RepOrderShipToEnum | undefined { return this.binders.order.shipTo; }
  set shipTo(value: RepOrderShipToEnum | undefined) {
    this.binders.order.shipTo = value;
    if (value == RepOrderShipToEnum.Customer) {
      // trigger the fetch (through the setter) of the Location Contact & Address info
      this.shipToLocation = this.binders.order.shipToLocation;
      console.warn('set shipToLocation', this.shipToLocation);
    }
  }
  get shipToLocation(): CustomerLocation | undefined { return this.binders.order.shipToLocation; }
  set shipToLocation(value: CustomerLocation | undefined) {
    console.warn('set shipToLocation', value);
    this.binders.order.shipToLocation = value;

    if (value) {
      // need to get Customer Location using CustomerLocation service to retrieve the full CustomerLocation object,
      // rather than just the row contained in the Customer > Locations grid
      this.customerLocationsService.get(this.binders.order!.customer!.CustomerID!, value?.LocationID, {
        loader: {
          indicator: LoadingIndicator.snackbar,
          message: 'Getting Location Details'
        }
      }).subscribe(location => {
        this.binders.order!.ShipToContact = location.GetOrderContact();
        this.binders.order!.ShipToAddress = location.GetOrderAddress();
        console.warn(this.binders.order!.ShipToContact, this.binders.order!.ShipToAddress);
      });
    }
  }
  get orderBinderShells(): boolean { return this.binders.order.orderBinderShells; }
  set orderBinderShells(value: boolean) { this.binders.order.orderBinderShells = value; }
  get anyShippedComponents() { return this.binders.anyShippedComponents; }
  get anyEmptyBinderShells() { return this.binders.anyEmptyBinderShells; }
  get customerLocations() { return this.binders.order.customer?.Locations; }
  get allCardsAudited() { return this.orderCards && Object.keys(this.orderCards).length == 0; }
  get anyBindersAudited() { return this.binders.Binders.filter(binder => binder.UserAudited).length > 0; }
  get order() { return this.binders.order; }
  get customer() { return this.binders.order.customer!; }
  // get ShipToContact() { return this.binders.order.ShipToContact!; }
  // get ShipToContactOverride() { return this.binders.order.ShipToContactOverride; }
  // set ShipToContactOverride(value: boolean) { this.binders.order.ShipToContactOverride = value; }
  // get ShipToAddress() { return this.binders.order.ShipToAddress!; }
  // get ShipToAddressOverride() { return this.binders.order.ShipToAddressOverride; }
  // set ShipToAddressOverride(value: boolean) { this.binders.order.ShipToAddressOverride = value; }

  // #region Container / Grouping
  /** return the container description (binder name or item group) for the given order component */
  containerDescription = (orderComponent: OrderComponent) => (!orderComponent.containingBinder ? '' : (this.binders.LooseCards ? orderComponent.containingBinder.ItemsetGroup : orderComponent.containingBinder.Description));
  /** return a string[] of all the containers (binders names or item groups) from which cards are missing */
  get containerDescriptions(): string[] { return this.orderCards!.map(card => this.containerDescription(card)).unique<string>(); }
  /** return all of the order components (cards) for the given container */
  cardsInContainer(containerDescription: string): OrderComponent[] { return this.orderCards!.filter(card => this.containerDescription(card) == containerDescription) }
  // #endregion

  // #endregion

  ngOnInit(): void {
    if (!this.binders.order.customer && !this.isDevMode) this.router.navigate(['/binder-audit']);

    this.binders.getOrderComponents().subscribe(components => {
      this.orderCards = Object.values(components)
        .filter(component => component.kitComponent.componentType == KitStockComponentTypeEnum.Card)
        .sort((a: OrderComponent, b: OrderComponent) => {
          if (a.containingBinder && b.containingBinder && a.containingBinder != b.containingBinder)
            return a.containingBinder.SortOrder - b.containingBinder.SortOrder;
          return a.kitComponent.Description!.localeCompare(b.kitComponent.Description!);
        });

      this.orderBinders = Object.values(components)
        .filter(component => component.kitComponent.componentType == KitStockComponentTypeEnum.BinderShell)
        .sort((a: OrderComponent, b: OrderComponent) =>
          this.binders.BinderShells.indexOf(this.binders.BinderShells.find(binder => binder.InventoryID == a.kitComponent.InventoryID)!) -
          this.binders.BinderShells.indexOf(this.binders.BinderShells.find(binder => binder.InventoryID == b.kitComponent.InventoryID)!)
        );

      Object.values(this.orderCards).forEach(card => {
        card.inventoryAvailable.subscribe(() => {
          if (card.RepAvail! > 0) {
            card.source = CardAuditFillSourceEnum.SalesRep;
          } else if (card.WhseAvail! < this.LowSupplyQtyThreshold) {
            card.source = CardAuditFillSourceEnum.Omit;
          } else {
            card.source = CardAuditFillSourceEnum.Shipment;
          }
        })
      })
    });
  }

  // #region UI template exposures
  LifeCycleColor = this.mayerfabrics.LifeCycleColor;
  LifeCycleContrastColor = this.mayerfabrics.LifeCycleContrastColor;
  // #endregion

  shipLowSupplyCards: boolean = false;
  confirmWhseSupplyShipment(orderCard: OrderComponent) {
    if (!this.shipLowSupplyCards && orderCard.WhseAvail! < this.LowSupplyQtyThreshold || orderCard.WhseAvail == 0) {
      this.dialog.open(ConfirmationDialog, {
        data: {
          icon: 'help',
          message: orderCard.WhseAvail == 0
            ? "There is currently none of this item available in the warehouse.\n\nContinue with order placement?"
            : "The warehouse supply of this item is low. Please only send to high volume customers.",
          buttons: [
            { text: 'Cancel', value: undefined },
            {
              text: orderCard.WhseAvail == 0 ? 'Place order' : 'Send it',
              value: true
            },
            { text: 'Omit it', value: false, color: 'primary' },
          ]
        }
      }).afterClosed().subscribe(response => {
        switch (response) {
          case undefined:
            orderCard.source = CardAuditFillSourceEnum.Unspecified;
            break;
          case true:
            orderCard.source = CardAuditFillSourceEnum.Shipment;
            this.shipLowSupplyCards = true;
            break;
          case false:
            orderCard.source = CardAuditFillSourceEnum.Omit;
            this.shipLowSupplyCards = false;
            break;
        }
      })
    }
  }

  validateOrder(): Observable<void> {
    return new Observable<void>(subscriber => {
      if (this.orderCards === undefined) {
        subscriber.next();
        subscriber.complete();
        return;
      }

      // check if any cards are still 'Unspecified'
      let unspecifiedCard = Object.values(this.orderCards).find(item => item.source == CardAuditFillSourceEnum.Unspecified);
      if (unspecifiedCard) {
        this.dialog.open(AlertDialog, {
          data: {
            sound: Sound.GentleBeep,
            message: "You have not specified a source for\n" + unspecifiedCard.kitComponent.InventoryID + " - " + unspecifiedCard.kitComponent.Description,
            icon: 'warning',
            buttonText: 'Ok'
          }
        });
        subscriber.complete();
        return;
      }

      // check if cards are to be Shipped but ship-to is unspecified
      if (this.binders.anyShippedComponents && this.binders.order.shipTo === undefined) {
        this.dialog.open(AlertDialog, {
          data: {
            sound: Sound.GentleBeep,
            message: "You have cards marked to be Shipped. Please specify to ship them to you or the directly to the customer",
            icon: 'warning',
            buttonText: 'Ok'
          }
        });
        subscriber.complete();
        return;
      }

      // // check if any binder shells are being placed but shell delivery is unspecifed
      // if (this.binders.order.placedBinderShells.length > 0 && this.binders.order.shipToBinders === undefined) {
      //   this.dialog.open(AlertDialog, {
      //     data: {
      //       sound: Sound.GentleBeep,
      //       message: "You have binder shells marked as being placed. Please specify if you're placing them from your supply or they should be shipped to the customer",
      //       icon: 'warning',
      //       buttonText: 'Ok'
      //     }
      //   });
      //   subscriber.complete();
      //   return;
      // }

      subscriber.next();
      subscriber.complete();
    });
  }

  placeOrder() {
    this.validateOrder().subscribe(() => {
      // log the audit info to the server before attempting to update Customer Binders & create SOs
      let orderInfo = <any>{ ...this.order };
      orderInfo.customer = orderInfo.customer?.CustomerID;
      orderInfo.shipTo = (this.order.shipTo == RepOrderShipToEnum.SalesRep) ? "Sales Rep" : "Customer";
      delete orderInfo.orderBinderShells;
      let logData = {
        ship_items: Object.keys(this.binders.orderComponents)
          .filter(inventoryID => this.binders.orderComponents[inventoryID].source == CardAuditFillSourceEnum.Shipment),
        placed_items: Object.keys(this.binders.orderComponents)
          .filter(inventoryID => this.binders.orderComponents[inventoryID].source == CardAuditFillSourceEnum.SalesRep),
        shipment: orderInfo
      }
      this.logger.log(this.acumatica.username, "Rep Binder Audit", JSON.stringify(logData));

      // do the Acumatica updates
      let dialogRef = this.dialog.open(AcumaticaLoadingDialogComponent, { data: { message: "Updating Customer Sample Books" } });
      this.binders.UpdateCustomerSampleBooks().subscribe(() => {
        dialogRef.close();

        if (this.binders.anyComponentsOnOrder) {
          this.binders.createSalesOrder().subscribe(so => {
            this.binders.resetAuditOrder();
            this.router.navigate(['/binder-audit/fill-rep-cards', so.OrderNbr])
          });
        } else {
          this.binders.resetAuditOrder();
          this.router.navigate(['/']);
        }
      });
    });

  }

  // overrideContactChange(event: MatSlideToggleChange) {
  //   if (event.checked) {
  //     this.binders.order.ShipToContact = new DocContact({
  //       BusinessName: this.binders.order.customer!.PrimaryContact?.CompanyName,
  //       Attention: this.binders.order.customer!.PrimaryContact?.DisplayName,
  //       Phone1: this.binders.order.customer!.PrimaryContact?.Phone1,
  //       Email: this.binders.order.customer!.PrimaryContact?.Email
  //     })
  //   }
  // }

  // overrideAddressChange(event: MatSlideToggleChange) {
  //   if (event.checked) {
  //     this.binders.order.ShipToAddress = new Address({
  //       AddressLine1: this.customer?.AddressLine1,
  //       AddressLine2: this.customer?.AddressLine2,
  //       City: this.customer?.City,
  //       State: this.customer?.State,
  //       PostalCode: this.customer?.PostalCode,
  //       Country: this.customer?.Country,
  //     });
  //   }
  // }
}